var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployeesRegisteredIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "employees-registered-icon",
    transform: "translate(0.407)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(-0.407)",
    fill: "#2477b3",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(24 23.993)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 10.233,
    cy: 10.233,
    r: 10.233,
    transform: "translate(8.837)",
    fill: "#09c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M22.971,29.2a11.617,11.617,0,0,1,.141-15.985q-1.367-.106-2.793-.108c-6.18,0-11.652,1.546-15.049,3.862-2.592,1.767-4.02,4.013-4.02,6.37v2.7A3.163,3.163,0,0,0,4.413,29.2Z",
    transform: "translate(-1.25 8.963)",
    fill: "#09c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M22.017,12.25a9.767,9.767,0,1,0,9.767,9.767A9.771,9.771,0,0,0,22.017,12.25ZM17.523,23.643l2.791,1.86a1.4,1.4,0,0,0,1.76-.175l4.651-4.651a1.394,1.394,0,0,0-1.972-1.972l-3.844,3.842L19.07,21.322a1.4,1.4,0,0,0-1.548,2.322Z",
    transform: "translate(8.215 8.226)",
    fill: "#09c",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeesRegisteredIcon);
export default __webpack_public_path__ + "static/media/employees-registered-icon.e6a631f35867e9a8f2b586376f12add2.svg";
export { ForwardRef as ReactComponent };